import React from 'react';
import Icon from '../../../components/AppIcon';

const DailyImpactAssessment = ({ impacts, onToggle }) => {
  const impactAreas = [
    { id: 'sleep', label: 'Sleep', icon: 'Moon' },
    { id: 'school', label: 'School/Work', icon: 'Briefcase' },
    { id: 'appetite', label: 'Appetite', icon: 'Utensils' },
    { id: 'mood', label: 'Mood', icon: '/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png' },
    { id: 'mobility', label: 'Mobility', icon: 'Move' },
    { id: 'social', label: 'Social Interaction', icon: 'Users' }
  ];

  return (
    <div className="space-y-4">
      <div className="mb-6">
        <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-bold text-foreground mb-2">
          How is this affecting your daily life?
        </h3>
        <p className="text-sm md:text-base text-muted-foreground">
          Toggle the areas that are impacted
        </p>
      </div>
      <div className="space-y-3">
        {impactAreas?.map((area) => {
          const isAffected = impacts?.includes(area?.id);
          return (
            <button
              key={area?.id}
              onClick={() => onToggle(area?.id)}
              className={`
                w-full flex items-center justify-between p-4 md:p-5 rounded-xl
                border-2 transition-smooth
                ${isAffected 
                  ? 'border-primary bg-primary/5 shadow-therapeutic' 
                  : 'border-border bg-card hover:border-primary/30 hover:shadow-therapeutic'
                }
                focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background
                active:scale-[0.99]
              `}
              aria-pressed={isAffected}
              aria-label={`${area?.label} ${isAffected ? 'affected' : 'not affected'}`}
            >
              <div className="flex items-center gap-4">
                <div className={`
                  flex items-center justify-center w-12 h-12 rounded-lg
                  ${isAffected ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'}
                  transition-smooth
                `}>
                  <Icon name={area?.icon} size={20} strokeWidth={2} />
                </div>
                <span className="text-sm md:text-base font-medium text-foreground">
                  {area?.label}
                </span>
              </div>
              <div className={`
                relative w-14 h-8 rounded-full transition-smooth
                ${isAffected ? 'bg-primary' : 'bg-muted'}
              `}>
                <div className={`
                  absolute top-1 w-6 h-6 rounded-full bg-white shadow-therapeutic
                  transition-smooth
                  ${isAffected ? 'right-1' : 'left-1'}
                `} />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DailyImpactAssessment;